import BackgroundUrl from '@assets/bg.svg';
import LogoWithTextUrl from '@assets/logo-with-text.svg';
import { RacemapColors } from '@racemap/utilities/consts/common';
import { ConfigProvider, Flex, type ThemeConfig, Typography } from 'antd';
import { Outlet } from 'react-router';
import { useIsPhone } from 'src/lib/customHooks/useBreakpoint';
import { largeControlsTheme } from 'src/lib/theme';

const { Text } = Typography;

const brandBackground = { background: `${RacemapColors.CloudBlue} url(${BackgroundUrl})` };
const brandBorder = `1px solid ${RacemapColors.LightGray}`;
// #root pads 70px for the app header, which auth pages do not show
const fullPage = { position: 'fixed', inset: 0, overflow: 'auto', background: '#fff' } as const;

// antd puts a field error into the item's bottom margin; at 16px text it fills all of 24px
const authTheme: ThemeConfig = {
  ...largeControlsTheme,
  components: { Form: { itemMarginBottom: 32 } },
};

const logo = <img src={LogoWithTextUrl} height={50} alt="Racemap" />;

/** Brand panel left, step right; on phones the panel becomes the header bar. */
export function AuthLayout() {
  const isMobile = useIsPhone();
  const step = (
    <ConfigProvider theme={authTheme}>
      <Outlet />
    </ConfigProvider>
  );

  if (isMobile) {
    return (
      <Flex vertical style={fullPage}>
        <Flex
          align="center"
          style={{ ...brandBackground, height: 50, padding: '0 15px', borderBottom: brandBorder }}
        >
          {logo}
        </Flex>
        <div style={{ padding: '30px 20px' }}>{step}</div>
      </Flex>
    );
  }

  return (
    <Flex style={fullPage}>
      <Flex
        vertical
        justify="space-between"
        style={{
          ...brandBackground,
          flex: '0 0 480px',
          // stays in view while a long form scrolls past
          position: 'sticky',
          top: 0,
          height: '100%',
          boxSizing: 'border-box',
          padding: '20px 40px 40px 25px',
          borderRight: brandBorder,
        }}
      >
        <div>{logo}</div>
        <Flex vertical gap={7} style={{ paddingLeft: 15, maxWidth: 340 }}>
          <Text style={{ fontSize: 22, color: RacemapColors.DarkBlue }}>
            Livetracking for everyone.
          </Text>
          <Text style={{ color: RacemapColors.DarkBlue }}>
            Build tracking maps for your events and follow every athlete live.
          </Text>
        </Flex>
      </Flex>
      <Flex justify="center" flex={1} style={{ padding: '80px 40px', alignSelf: 'flex-start' }}>
        <div style={{ width: '100%', maxWidth: 400 }}>{step}</div>
      </Flex>
    </Flex>
  );
}
